import React from 'react';
import { Tooltip } from 'antd';
import { summaryFromSegment } from '../segment/segmentHumanize';
import SegmentSummary from '../segment/SegmentSummary';
import { attributeById as defaultAttributeById } from '../fixtures/attributes';

// Entry criteria for a journey, shown as compact chips (option 1: inline and/or,
// truncate). Hover reveals the full structured summary; the journey pencil edits it.
export default function SegmentBar({ segment, attributeById = defaultAttributeById, productById, maxChips = 3, showEmpty = false }) {
  const model = summaryFromSegment(segment, { attributeById, productById: productById || (() => null) });
  if (model.clauseCount === 0) {
    // No segment defined. On the timeline panel (showEmpty) render a muted "reaches everyone"
    // line so the header keeps its structure; elsewhere (e.g. gallery cards) render nothing.
    if (!showEmpty) return null;
    return (
      <div className="tl-segbar tl-segbar--empty">
        <div className="tl-segbar-lbl">TRIGGERS WHEN</div>
        <div className="tl-segbar-empty">Reaches everyone · no segment yet</div>
      </div>
    );
  }
  const g0 = model.groups[0];
  const joinWord = g0.op === 'any' ? 'or' : 'and';
  const shown = g0.clauses.slice(0, maxChips);
  const extraGroups = model.groups.length - 1;
  const moreInGroup = g0.clauses.length - shown.length;
  const moreLabel = extraGroups > 0
    ? `+${extraGroups} group${extraGroups > 1 ? 's' : ''}`
    : (moreInGroup > 0 ? `+${moreInGroup} more` : '');
  return (
    <Tooltip color="#fff" placement="right" title={<SegmentSummary model={model} className="seg-summary--tip" />}>
      <div className="tl-segbar">
        <div className="tl-segbar-lbl">TRIGGERS WHEN</div>
        <div className="tl-chips">
          {shown.map((c, i) => (
            <React.Fragment key={i}>
              {i > 0 && <span className="tl-chip-join">{joinWord}</span>}
              <span className="tl-chip">{c.plain.charAt(0).toUpperCase() + c.plain.slice(1)}</span>
            </React.Fragment>
          ))}
          {moreLabel && <span className="tl-chip tl-chip-more">{moreLabel}</span>}
        </div>
      </div>
    </Tooltip>
  );
}
